const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCovid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "r00c2xfmga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 80",
    transform: "translate(-.764)",
    style: {
      fill: "#9c9c9c"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 304",
    transform: "translate(.764)",
    style: {
      clipPath: "url(#r00c2xfmga)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4268",
    d: "M11.236 0C5.026 0 0 5.367 0 12s5.026 12 11.236 12 11.236-5.367 11.236-12S17.447 0 11.236 0zM6.527 20.792A10.252 10.252 0 0 1 1.756 12a10.047 10.047 0 0 1 6.9-9.748c1.552.705 4.676 2.437 5.093 4.156a1.466 1.466 0 0 1-.355 1.33 4.45 4.45 0 0 1-3.437 1.916 2.838 2.838 0 0 0-1.482.465 2.155 2.155 0 0 0-.624 1.991c.156 1.411.363 3.1.4 4.537.053 1.83-.2 2.223-.234 2.261a72.647 72.647 0 0 1-1.49 1.884zm4.71 1.333A8.949 8.949 0 0 1 8.2 21.6a84.47 84.47 0 0 0 1.186-1.5c1.1-1.439.516-5.438.211-8.2a1.841 1.841 0 0 1-.013-.282 5.193 5.193 0 0 1 .58-.093 6.146 6.146 0 0 0 4.59-2.583 3.443 3.443 0 0 0 .7-3C15.116 4.557 13.915 3.2 11.88 1.9a9.8 9.8 0 0 1 8.8 9.193c-.378.02-.837.055-1.3.115-1.291.165-2.8.508-3.023 1.707a10.1 10.1 0 0 1-2.274 4.249 2.016 2.016 0 0 0-.615 1.58 4.586 4.586 0 0 0 1.384 2.625 8.945 8.945 0 0 1-3.616.756zm5.249-1.69a4.01 4.01 0 0 1-1.268-1.79c0-.039 0-.052.047-.1a11.939 11.939 0 0 0 2.774-5.093 5.162 5.162 0 0 1 1.854-.419c.276-.029.543-.049.782-.063a10.241 10.241 0 0 1-4.19 7.465z",
    style: {
      fill: "#9c9c9c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovid);
export default __webpack_public_path__ + "static/media/covid.f6a54c05868bbed132cc6911443013cf.svg";
export { ForwardRef as ReactComponent };